import { useEffect, useState } from 'react';
import { getMessages } from './lib/api/message';
import './App.css';

interface Message {
  id: number;
  title: string;
  body: string;
}

function App() {
  const [messages, setMessages] = useState<Message | null>(null);

  useEffect(() => {
    getMessages().then((response) => {
      setMessages(response.data);
    });
  }, []);

  if (!messages) {
    return <div>Loading...</div>;
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src="../zportLogo.webp" className="App-logo" alt="logo" />
          <h1>{messages.title}</h1>
          <p>{messages.body}</p>
      </header>
    </div>
  );
}

export default App;
